import React, { Component } from 'react';
import './App.css';
import { Layout, Header, Navigation, Drawer, Content } from 'react-mdl';
import Main from './components/main';
import { Link } from 'react-router-dom';
import pdf from './Documents/resume.pdf';


class App extends Component {
  render() {
    return (
      <div className="demo-big-content">
    <Layout>
        <Header className="header-color" title={<Link style={{textDecoration: 'none', color: 'white', fontSize: '110%'}} to="/">Donovan Buccat</Link>} scroll>
            <Navigation>
                <a href = {pdf} rel="noopener noreferrer" target = {"_blank"} style={{color: 'white', fontSize: '117%'}} >Resume</a>
                <Link style={{color: 'white', fontSize: '110%'}} to="/aboutme">About Me</Link>
                <Link style={{color: 'white', fontSize: '110%'}} to="/projects">Projects</Link>
                <Link style={{color: 'white', fontSize: '110%'}} to="/contact">Contact</Link>
            </Navigation>
        </Header>
        <Drawer title={<Link style={{textDecoration: 'none', color: 'black'}} to="/">Portfolio</Link>}>
            <Navigation>
              <a href = {pdf} rel="noopener noreferrer" target = {"_blank"}>Resume</a>
              <Link to="/aboutme">About Me</Link>
              <Link to="/projects">Projects</Link>
              <Link to="/contact">Contact</Link>
            </Navigation>
        </Drawer>
        <Content>
            <div className="page-content" />
            <Main/>
        </Content>
    </Layout>
</div>

    );
  }
}

export default App;
